<template>
  <div>
    <v-progress-linear v-show="loading" :indeterminate="true" :active=loading color="#1fabe2"></v-progress-linear>
    <ul class="nav nav-tabs">
      <li role="presentation" v-for="(dealershipItem, key) in dealerships" :key="dealershipItem.id" :class="{active: (dealership === null && key === 0) || (dealership !== null && dealership.id === dealershipItem.id)}">
        <a href="#" v-on:click.prevent="dealership = dealershipItem">
          <i class="fa fa-map-marker"></i> {{ sanitizeDealerName(dealershipItem.name) }}
          <!--<v-icon v-show="dealershipItem.pendingProcesses > 0" small color="red">notifications</v-icon>-->
          <!--<span v-if="dealershipItem.pendingProcesses > 0">({{ dealershipItem.pendingProcesses}})</span>-->
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import WebService from '@/utils/webservice'
export default {
  name: 'PromotionsSelectDealsershipComponent',
  props: ['promotionId'],
  data () {
    return {
      dealership: null,
      dealerships: [],
      loading: false
    }
  },

  watch: {
    dealership (dealership) {
      this.$emit('dealershipChange', dealership)
    },
    promotionId () {
      this.requestDealerships()
    }
  },

  methods: {

    sanitizeDealerName (dealerName) {
      let exceed = 30

      return dealerName.length > exceed ? `${dealerName.substring(0, exceed)}…` : dealerName
    },

    requestDealerships () {
      this.dealerships = []
      this.dealership = null
      this.loading = true
      WebService.promotions.findDealershipsFromPromotionId(this.promotionId).then(dealerships => {
        this.dealerships = dealerships
        if (this.dealerships.length > 0) {
          this.dealership = this.dealerships[0]
        }
      }).finally(() => {
        this.loading = false
      })
    }
  },

  mounted () {
    this.requestDealerships()
  }
}
</script>

<style lang="scss">

  .nav-dealerships {
    max-width: 300px;
    font-size: 0.9em;
  }

</style>



// WEBPACK FOOTER //
// src/components/custom/promotions/PromotionsSelectDealershipComponent.vue